import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Initialize isInitialized flag
(i18n as any).isInitialized = false;

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,

    // Lazy-load translation files per language via HTTP backend
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
      allowMultiLoading: false,
    },

    supportedLngs: ['en','ar','hi','ur','bn','fr','de','zh','ja'],
    load: 'languageOnly',
    partialBundledLanguages: true,
    preload: [],
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },

    interpolation: {
      escapeValue: false // React already does escaping
    },

    react: {
      useSuspense: false
    },

    // Add missing key handling
    missingKeyHandler: (lng, ns, key, fallbackValue) => {
      console.warn(`Missing translation key: ${key} for language: ${lng}`);
      return fallbackValue || key;
    },

    // Add save missing keys
    saveMissing: false
  }, (err, t) => {
    if (err) {
      console.error('i18n initialization error:', err);
    } else {
      // Mark i18n as initialized
      (i18n as any).isInitialized = true;

      // Test if translations are loading (silent check)
      setTimeout(() => {
        const testKey = t('auth.welcome') || 'auth.welcome';
        if (testKey === 'auth.welcome') {
          console.warn('⚠️ Translations not loading properly');
        }
      }, 1000);
    }
  });

export default i18n;
